import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { getEvent } from '~/selectors/event';
import { FieldMandatory } from '~/types/common';
import { updatePreNeedViewer } from '~/api/NewViewer';
import { Input, Mobile } from '~/elements/Input';
import { mandatoryField } from '~/utils/featureToggle';
import schema from './contactCaptureForm.schema';
import Loader from '~/elements/Loader';
import { Form, SubmitButton, TermsAndConditions } from '~/components/PreNeedPopup/threeStepsPreNeedPopup.styles';
import { useContatCaptureForm } from './contactCaptureForm.logic';
import { stripLeadingPlus } from '~/utils/validation';
const ContactCaptureForm = (props) => {
    const { loading, setLoading, country, IS_USA, contactData } = useContatCaptureForm(Number(props.event.id));
    const POSTCODE_MANDATORY = mandatoryField(FieldMandatory.postcode_mandatory);
    const { control, handleSubmit, setValue, reset } = useForm({
        resolver: yupResolver(schema(country?.toUpperCase() ?? 'NZ')),
        defaultValues: contactData
    });
    useEffect(() => {
        reset(contactData);
    }, [contactData]);
    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        try {
            await updatePreNeedViewer(Number(props.event.id), data.fullName, data.oldEmail, data.email, stripLeadingPlus(data.mobile, data.mobileCountry), data.zip || '', props.preNeedOption);
            props.onRegister();
        }
        catch (error) {
            console.error('updatePreNeedViewer error:', error);
        }
    });
    const updateMobile = (value, mobileCountry) => {
        setValue('mobile', value, {
            shouldDirty: true,
        });
        setValue('mobileCountry', mobileCountry, {
            shouldDirty: true,
        });
    };
    return (_jsxs(Form, { onSubmit: onSubmit, children: [_jsx(Input, { label: "Name", name: "fullName", control: control, isRequired: true }), _jsx(Input, { label: "Email", type: "email", name: "email", control: control, isRequired: true, onChange: (e) => setValue('email', e.target.value) }), _jsx("input", { name: "oldEmail", type: "hidden", value: contactData.oldEmail }), _jsx(Mobile, { label: "Mobile Number", name: "mobile", control: control, isRequired: true, defaultCountry: country, updateMobile: updateMobile }), _jsx(Input, { label: IS_USA ? 'Zip Code' : 'Postcode', name: "zip", control: control, isRequired: POSTCODE_MANDATORY }), _jsx(Input, { label: "Terms and Conditions", name: "tandc", control: control, type: "checkbox", children: _jsxs(TermsAndConditions, { children: ["I agree to the", ' ', _jsx("a", { href: "https://www.oneroomstreaming.com/terms-and-conditions", target: "_blank", rel: "noreferrer", children: "T & C" }), ' ', "and", ' ', _jsx("a", { href: "https://www.oneroomstreaming.com/privacy-policy", target: "_blank", rel: "noreferrer", children: "Privacy Policy" })] }) }), _jsx(SubmitButton, { disabled: loading, children: loading ? _jsx(Loader, { size: 24, color: "white" }) : 'Submit' })] }));
};
const mapStateToProps = (state) => ({
    event: getEvent(state),
});
export default connect(mapStateToProps)(ContactCaptureForm);
